/* 
 * This script loads basic foundation components and
 * special components like sliders, tabs, etc on demand / async
 * 
 * Requires: 
 *	- foundation.core.js
 *	- foundation.util.keyboard.js
 *	- foundation.util.motion.js 
 *	- foundation.util.mediaQuery.js
 *	- foundation.orbit.js / on demand
 * 
 *	Author: Michael Kohler <michael.kohler@somedia.ch>
 */

// Rquire Foundation core and most used utils
var $ = require('jquery');
require('foundation-sites');

var foundationModules = [
	require('./foundation.sticky'),
	require('./foundation.accordion'),
	require('./foundation.tooltip'),
	require('./foundation.tabs')
];

// Modul construct
var somModul = {
	
	// Module name
	name: 'foundation',
	
	// Container
	container: null,
	
	// Init function
	init: function() {

		// Init interchange on content images
		$('img.resp-img').foundation();

		// Orbit slider - on demand
		if($('.orbit').length != 0) {
			var scope = this;
			require.ensure([], function() {
				scope.__initComponents([require('./foundation.orbit')]);
			});
		}
		
		// All other foundation modules
		this.__initComponents(foundationModules);
		
		return true;
	}
};

// Return modul construct - commonJS syntax
module.exports = somModul;



/** WEBPACK FOOTER **
 ** ./src/components/foundation.js
 **/